import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Address_Interface, Empty_Address_Interface } from 'src/app/Interface/Address_Interface';
import { Customer_Interface, Empty_Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_KarshnasMasol_Interface, KarshnasMasol_Interface } from 'src/app/Interface/KarshnasMasol_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { FeildActivityService } from 'src/app/Service/FeildActivity/FeildActivity.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { ProvinceService } from 'src/app/Service/Province/Province.service';

@Component({
  selector: 'app-CutomerInfo',
  templateUrl: './CutomerInfo.component.html',
  styleUrls: ['./CutomerInfo.component.scss']
})
export class CutomerInfoComponent implements OnInit {

  Token: String = ""
  //EditRecord:Number
  Edit_Customer_Record: Customer_Interface = Empty_Customer_Interface()

  constructor(
    private province_Service: ProvinceService,
    private Alerify: AlertifyService,
    private Nav_Service: NavService,
    private FeildActivity_Service: FeildActivityService,
    private Customer_Service: CustomerService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 1117).subscribe(
      data => {
        this.Read_Service_Province("")
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )


    this.EdCustomer = new FormGroup({
      id: new FormControl(0),
      Code: new FormControl(null, Validators.required),
      Name: new FormControl(null, Validators.required),
      //ProvinceId:new FormControl("0"),
      //CityId:new FormControl("0"),
      //FeildActivity:new FormControl("0"),
      ShomarehSabt: new FormControl(null, Validators.pattern('^[0-9]{11}$')),
      CodeEghtesadi: new FormControl(null, Validators.pattern('^[0-9]{12}$')),
      CodeMeli: new FormControl(null, Validators.pattern('^[0-9]{9}$')),

      ModirAmelName: new FormControl(null),
      ModirAmelMobile: new FormControl(null),
      //ModirAmelMobile: new FormControl(null, Validators.pattern('^[0-9]{10}$')),
      ModirAmelTel: new FormControl(null),
      ModirAmelDakheli: new FormControl(null),
      ModirAmelEmail: new FormControl(null),
    })


    this.AddressCustomer = new FormGroup({
      id: new FormControl(),
      title: new FormControl(null, Validators.required),
      address: new FormControl(null),
      codepost: new FormControl(null),
      sandoghpost: new FormControl(null),
      pishShomareh: new FormControl(null),
      certificateAddress: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
      Tel: new FormControl(null),
      Dakheli: new FormControl(null),
      Fax: new FormControl(null),
      Dsc: new FormControl(null),
    })

  }
  ReadData_Initial_Status: boolean = false
  ReadData_Initial() {
    //this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))
    this.Customer_Service.GetSingle(this.Token, -1).subscribe(
      data => {
        this.DataList_Address = data['address']

        for (let item of this.DataList_KarshnasMasol) {
          item.Dakhli = []

          for (let itemDetail of item.dakhli_temp.split(',')) {
            if (itemDetail != "-1") {
              item.Dakhli.push({
                id: 0,
                title: itemDetail,
                code: '',
                dsc: '',
                del: false,
                DeletingProccess: false
              })
            }

          }

          item.dakhli_temp = '-1'
        }



        for (let item of this.DataList_KarshnasMasol) {
          item.Email = []

          for (let itemDetail of item.email_temp.split(',')) {
            if (itemDetail != "-1") {
              item.Email.push({
                id: 0,
                title: itemDetail,
                code: '',
                dsc: '',
                del: false,
                DeletingProccess: false
              })
            }

          }
          item.email_temp = '-1'
        }

        for (let item of this.DataList_KarshnasMasol) {
          item.Tel = []

          for (let itemDetail of item.tel_temp.split(',')) {
            if (itemDetail != "-1") {
              item.Tel.push({
                id: 0,
                title: itemDetail,
                code: '',
                dsc: '',
                del: false,
                DeletingProccess: false
              })
            }

          }
          item.tel_temp = '-1'
        }

        this.Edit_Customer_Record = data['model']
        this.get_Form_Code().setValue(this.Edit_Customer_Record.code)
        this.get_Form_Name().setValue(this.Edit_Customer_Record.name)

        this.get_Form_CodeEghtesadi().setValue(this.Edit_Customer_Record.codeEghtesadi)
        this.get_Form_ShomarehSabt().setValue(this.Edit_Customer_Record.shomarehSabt)
        this.get_Form_CodeMeli().setValue(this.Edit_Customer_Record.codeMeli)

        this.get_Form_ModirAmelName().setValue(this.Edit_Customer_Record.modirAmelName)
        this.get_Form_ModirAmelMobile().setValue(this.Edit_Customer_Record.modirAmelMobile)
        this.get_Form_ModirAmelTel().setValue(this.Edit_Customer_Record.modirAmelTel)
        this.get_Form_ModirAmelDakheli().setValue(this.Edit_Customer_Record.modirAmelDakheli)
        this.get_Form_ModirAmelEmail().setValue(this.Edit_Customer_Record.modirAmelEmail)
        //this.get_Form_ProvinceId().setValue(this.Edit_Customer_Record.province_id)
        //this.get_Form_FeildActivity().setValue(this.Edit_Customer_Record.feildActivity_id)
        this.Read_Service_Province(this.Edit_Customer_Record.province_id)
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  DataList_FeildActivity: Array<FeildActivity_Interface> = []
  ReadData_FeildActivity() {
    this.FeildActivity_Service.GetRecord(this.Token).subscribe(
      data => {
        this.DataList_FeildActivity = data
        this.ReadData_Initial()

      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }


  //#region  Form Edit

  EdCustomer: FormGroup;

  get_Form_id() {
    return this.EdCustomer.get('id') as FormControl;
  }


  get_Form_Code() {
    return this.EdCustomer.get('Code') as FormControl;
  }

  get_Form_Name() {
    return this.EdCustomer.get('Name') as FormControl;
  }
  /*
  get_Form_ProvinceId(){
    return this.EdCustomer.get('ProvinceId') as FormControl;
  }

  get_Form_CityId(){
    return this.EdCustomer.get('CityId') as FormControl;
  }

  get_Form_FeildActivity(){
    return this.EdCustomer.get('FeildActivity') as FormControl;
  }
  */

  get_Form_ShomarehSabt() {
    return this.EdCustomer.get('ShomarehSabt') as FormControl;
  }

  get_Form_CodeEghtesadi() {
    return this.EdCustomer.get('CodeEghtesadi') as FormControl;
  }

  get_Form_CodeMeli() {
    return this.EdCustomer.get('CodeMeli') as FormControl;
  }

  get_Form_ModirAmelName() {
    return this.EdCustomer.get('ModirAmelName') as FormControl;
  }

  get_Form_ModirAmelMobile() {
    return this.EdCustomer.get('ModirAmelMobile') as FormControl;
  }

  get_Form_ModirAmelTel() {
    return this.EdCustomer.get('ModirAmelTel') as FormControl;
  }

  get_Form_ModirAmelDakheli() {
    return this.EdCustomer.get('ModirAmelDakheli') as FormControl;
  }

  get_Form_ModirAmelEmail() {
    return this.EdCustomer.get('ModirAmelEmail') as FormControl;
  }

  //#endregion


  //#region Province

  DataList_Province: Array<General_Interface> = []
  DataList_City: Array<General_Interface> = []

  Read_Service_Province(id: string) {
    this.province_Service.GetRecord(id, this.Token).subscribe(
      data => {
        if (id == "") {
          this.DataList_Province = data
          this.ReadData_FeildActivity()
        }
        else {
          this.DataList_City = data
          if (!this.ReadData_Initial_Status) {
            this.ReadData_Initial_Status = true
            //this.get_Form_CityId().setValue(this.Edit_Customer_Record.city_id)
          }

        }
      }, error => {
        localStorage.clear()
        location.reload();

      }
    )
  }
  /*
    ProvinceChange(){
      if(this.get_Form_ProvinceId().value=="0")
      {
        this.DataList_City=[]
      }
      else{
        this.Read_Service_Province(this.get_Form_ProvinceId().value)
      }
    }*/



  //#endregion


  //#region Responsible technician table

  DataList_KarshnasMasol:Array<KarshnasMasol_Interface>=[]

  set_KarshnasMasol(model:Array<KarshnasMasol_Interface>)
  {
    this.DataList_KarshnasMasol=model
  }

  //#endregion


  //#region Address form

  AddressCustomer: FormGroup;

  get_Form_AddressCustomer_id() {
    return this.AddressCustomer.get('id') as FormControl;
  }

  get_Form_AddressCustomer_title() {
    return this.AddressCustomer.get('title') as FormControl;
  }

  get_Form_AddressCustomer_address() {
    return this.AddressCustomer.get('address') as FormControl;
  }

  get_Form_AddressCustomer_codepost() {
    return this.AddressCustomer.get('codepost') as FormControl;
  }

  get_Form_AddressCustomer_sandoghpost() {
    return this.AddressCustomer.get('sandoghpost') as FormControl;
  }

  get_Form_AddressCustomer_pishShomareh() {
    return this.AddressCustomer.get('pishShomareh') as FormControl;
  }

  get_Form_AddressCustomer_certificateAddress() {
    return this.AddressCustomer.get('certificateAddress') as FormControl;
  }

  get_Form_AddressCustomer_Tel() {
    return this.AddressCustomer.get('Tel') as FormControl;
  }

  get_Form_AddressCustomer_Dakheli() {
    return this.AddressCustomer.get('Dakheli') as FormControl;
  }

  get_Form_AddressCustomer_Fax() {
    return this.AddressCustomer.get('Fax') as FormControl;
  }

  get_Form_AddressCustomer_Dsc() {
    return this.AddressCustomer.get('Dsc') as FormControl;
  }




  //#endregion


  //#region Address

  DataList_Address: Array<Address_Interface> = []
  OnSubmit_AddressForm() {
    if (this.AddressForm_Edit_Id == -1) {

      if (this.DataList_Address.length < 3) {
        var temp: Address_Interface = Empty_Address_Interface()
        temp.id = 0
        temp.title = this.get_Form_AddressCustomer_title().value
        temp.address = this.get_Form_AddressCustomer_address().value
        temp.codepost = this.get_Form_AddressCustomer_codepost().value
        temp.sandoghpost = this.get_Form_AddressCustomer_sandoghpost().value
        temp.pishShomareh = this.get_Form_AddressCustomer_pishShomareh().value
        temp.certificateAddress = this.get_Form_AddressCustomer_certificateAddress().value
        temp.tel = this.get_Form_AddressCustomer_Tel().value
        temp.dakheli = this.get_Form_AddressCustomer_Dakheli().value
        temp.fax = this.get_Form_AddressCustomer_Fax().value
        temp.dsc = this.get_Form_AddressCustomer_Dsc().value



        this.DataList_Address.push(temp)

        this.Alerify.SuccessMessage("The address was added to the list.")
      }
      else {
        this.Alerify.ErrorMessage("No more than 3 addresses can be registered.")
      }
    }
    else {

      this.DataList_Address[this.AddressForm_Edit_Id].id = this.get_Form_AddressCustomer_id().value
      this.DataList_Address[this.AddressForm_Edit_Id].title = this.get_Form_AddressCustomer_title().value
      this.DataList_Address[this.AddressForm_Edit_Id].address = this.get_Form_AddressCustomer_address().value
      this.DataList_Address[this.AddressForm_Edit_Id].codepost = this.get_Form_AddressCustomer_codepost().value
      this.DataList_Address[this.AddressForm_Edit_Id].sandoghpost = this.get_Form_AddressCustomer_sandoghpost().value
      this.DataList_Address[this.AddressForm_Edit_Id].certificateAddress = this.get_Form_AddressCustomer_certificateAddress().value
      this.DataList_Address[this.AddressForm_Edit_Id].pishShomareh = this.get_Form_AddressCustomer_pishShomareh().value
      this.DataList_Address[this.AddressForm_Edit_Id].tel = this.get_Form_AddressCustomer_Tel().value
      this.DataList_Address[this.AddressForm_Edit_Id].dakheli = this.get_Form_AddressCustomer_Dakheli().value
      this.DataList_Address[this.AddressForm_Edit_Id].fax = this.get_Form_AddressCustomer_Fax().value
      this.DataList_Address[this.AddressForm_Edit_Id].dsc = this.get_Form_AddressCustomer_Dsc().value

      this.Alerify.SuccessMessage("The address was updated.")
      this.AddressForm_Edit_Id = -1
    }

    this.AddressCustomer.reset();

  }

  AddressForm_Delete(id) {
    this.DataList_Address.splice(id, 1)
    this.Alerify.SuccessMessage("Deleted successfully.")
  }

  AddressForm_Edit_Id: number = -1
  AddressForm_Edit(id) {
    this.AddressForm_Edit_Id = id

    var temp = this.DataList_Address[id]

    this.get_Form_AddressCustomer_id().setValue(temp.id)
    this.get_Form_AddressCustomer_title().setValue(temp.title)
    this.get_Form_AddressCustomer_address().setValue(temp.address)
    this.get_Form_AddressCustomer_codepost().setValue(temp.codepost)
    this.get_Form_AddressCustomer_sandoghpost().setValue(temp.sandoghpost)
    this.get_Form_AddressCustomer_pishShomareh().setValue(temp.pishShomareh)
    this.get_Form_AddressCustomer_certificateAddress().setValue(temp.certificateAddress)
    this.get_Form_AddressCustomer_Tel().setValue(temp.tel)
    this.get_Form_AddressCustomer_Dakheli().setValue(temp.dakheli)
    this.get_Form_AddressCustomer_Fax().setValue(temp.fax)
    this.get_Form_AddressCustomer_Dsc().setValue(temp.dsc)


  }

  AddressForm_Edit_Cancel() {
    this.AddressForm_Edit_Id = -1
    this.AddressCustomer.reset();
  }

  //#endregion

  Proccesing_OnSubmitForm: boolean = false
  OnSubmitForm() {
    /*
    if (this.get_Form_CityId().value == "0") {
      this.Alerify.ErrorMessage("Select the city.")
    }
    else if (this.get_Form_FeildActivity().value == "0") {
      this.Alerify.ErrorMessage("Select the field of activity.")
    }
    else {
      */
      this.Proccesing_OnSubmitForm = true
      var CustomerRecord: Customer_Interface = Empty_Customer_Interface()
      CustomerRecord.id = this.Edit_Customer_Record.id

      //CustomerRecord.city_id = Number(this.get_Form_CityId().value)
      //CustomerRecord.feildActivity_id = Number(this.get_Form_FeildActivity().value)
      CustomerRecord.shomarehSabt = this.get_Form_ShomarehSabt().value
      CustomerRecord.codeEghtesadi = this.get_Form_CodeEghtesadi().value
      CustomerRecord.codeMeli = this.get_Form_CodeMeli().value
      CustomerRecord.modirAmelName = this.get_Form_ModirAmelName().value
      CustomerRecord.modirAmelMobile = this.get_Form_ModirAmelMobile().value
      CustomerRecord.modirAmelTel = this.get_Form_ModirAmelTel().value
      CustomerRecord.modirAmelDakheli = this.get_Form_ModirAmelDakheli().value
      CustomerRecord.modirAmelEmail = this.get_Form_ModirAmelEmail().value

      this.Customer_Service.EditCustomer(
        CustomerRecord,
        this.DataList_KarshnasMasol,
        this.DataList_Address,
        [],
        this.Token).subscribe(
          data => {
            this.Proccesing_OnSubmitForm = false
            if (data.id == -1) {
              this.Alerify.ErrorMessage("The customer code already exists.")
            }
            else {
              this.Alerify.SuccessMessage("Information saved successfully.")


            }

          }, error => {
            localStorage.clear()
            location.reload();

          }
        )
    //}

  }










}

